import { AbstractControl, ValidationErrors } from '@angular/forms';

export function emailRequired(control: AbstractControl): ValidationErrors | null {
  const value = control.value || '';
  if (value === '') {
    return { email: true };
  }
  // eslint-disable-next-line max-len
  const expression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const isValid = expression.test(value.toLowerCase());

  if (isValid) {
    return null;
  }

  return {
    email: true
  };

}
